import { useState, useEffect, useCallback, useContext, Suspense } from "react";
import { trackPromise } from "react-promise-tracker";
import { Grid } from "@material-ui/core";
import { api } from "../../../../utils/api";
import {
	AssignedGroup,
	AssignedLocation,
	AssignmentStatus,
	GroupsAndLocations,
	LocationSchema
} from "../../../../@types/group.types";
import TreeView from "./treeView/TreeView";
import GroupInformation from "./groupInformation/GroupInformation";
import { GroupContext, UIContext } from "../../../../contexts";
import { useLocation } from "react-router-dom";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";

import SelectAllIcon from "@material-ui/icons/SelectAll";

import "./assignGroups.css";
import { Role } from "../../../../@types/role.types";

const AssignGroups = () => {
	const [groups, setGroups] = useState<GroupsAndLocations[]>([]);
	const [employer, setEmployer] = useState<any | null>();
	const [assignmentStatus, setAssignmentStatus] = useState<AssignmentStatus>();

	const [isSelectAllLocations, setIsSelectAllLocations] = useState<any>({});

	const { setDashboardHeader } = useContext(UIContext);
	const { groupInformation, locationInformation, setGroupInformation, setLocationInformation } =
		useContext(GroupContext);
	const { state } = useLocation() as { state: { user_id: string; role: Role } };

	const handleSelectProfile = (profile: GroupsAndLocations, type: "group" | "location") => {
		if (type === "group") {
			setGroupInformation(Object.assign({}, profile));
			setLocationInformation(null);
		} else if (type === "location") {
			setLocationInformation(Object.assign({}, profile));
			setGroupInformation(null);
		}
	};

	const handleSelectAllLocationsClick = useCallback(
		(groupSelected: any) => {
			const group_number = groupSelected.group_number;
			if (isSelectAllLocations[group_number]) {
				groups.forEach((group: any) => {
					if (group._id == groupSelected._id) {
						// const { _id, unassigned_locations, assigned_locations, group_number } = group;
						if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
							Object.keys(group["all_locations"]).forEach((_id: any) => {
								group["all_locations"][_id][0] = !isSelectAllLocations[group_number];
							});

							const atLeatstOneSelectedLocations = Object.keys(group["all_locations"]).reduce(
								(acc, _id) => acc || group["all_locations"][_id][0],
								group["group_assigned"]
							);

							group["group_assigned"] = atLeatstOneSelectedLocations;

							setGroups(Object.assign([], groups));
							// setFilteredGroups(Object.assign([], groups));
						}
					}
				});
				// handleAssignSelectedLocationsToTheGroups(groupSelected, isSelectAllLocations);
			} else {
				// handleAssignSelectedLocationsToTheGroups(groupSelected, isSelectAllLocations[group_number]);
				groups.forEach((group: any) => {
					if (group._id == groupSelected._id) {
						// const { _id, unassigned_locations, assigned_locations, group_number } = group;
						if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
							Object.keys(group["all_locations"]).forEach((_id: any) => {
								group["all_locations"][_id][0] = !isSelectAllLocations[group_number];
							});

							const atLeatstOneSelectedLocations = Object.keys(group["all_locations"]).reduce(
								(acc, _id) => acc || group["all_locations"][_id][0],
								group["group_assigned"]
							);

							group["group_assigned"] = atLeatstOneSelectedLocations;
							setGroups(Object.assign([], groups));
							// setFilteredGroups(Object.assign([], groups));
						}
					}
				});
			}
		},
		[groups, isSelectAllLocations]
	);

	const getGroups = useCallback(async () => {
		if (state.user_id) {
			const params = {
				user_id: state.user_id
			};
			const result = (await trackPromise(api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params))) as {
				groupsAndLocations: GroupsAndLocations[];
				assignmentStatus: AssignmentStatus;
			};
			if (result) {
				result.groupsAndLocations.forEach((group: any) => {
					const all_locations: any = {};
					const { _id, unassigned_locations, assigned_locations, group_number } = group;
					unassigned_locations.forEach((location: any) => {
						const { _id, location_number, location_name } = location;
						all_locations[_id] = [];
						all_locations[_id].push(false);
						all_locations[_id].push(location_number);
						all_locations[_id].push(location_name);
					});
					assigned_locations.forEach((location: any) => {
						const { _id, location_number, location_name } = location;
						all_locations[_id] = [];
						all_locations[_id].push(true);
						all_locations[_id].push(location_number);
						all_locations[_id].push(location_name);
					});
					group["all_locations"] = all_locations;
					group["group_assigned"] = group.assigned_group_info ? group.assigned_group_info.assigned : false;
				});
				setGroups(Object.assign([], result.groupsAndLocations));
				console.log("object", result.groupsAndLocations);
				setAssignmentStatus(Object.assign({}, result.assignmentStatus));
			}
		}
	}, [state.user_id]);

	// console.log("groups", groups);

	const handleAssignGroup = useCallback(
		async (_group: GroupsAndLocations) => {
			// console.log("_group", _group);
			const { _id, group_number } = _group;
			let allGroupSelected = true;
			let allLocationSelected = true;
			groups.forEach((group: any) => {
				if (group._id == _id) {
					if (_group["group_assigned"]) {
						if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
							Object.keys(group["all_locations"]).forEach((_id: string) => {
								_group["all_locations"][_id][0] = false;
							});
						}
					}
					group["group_assigned"] = !group["group_assigned"];

					allGroupSelected = allGroupSelected && group["group_assigned"];
				}
				if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
					allLocationSelected =
						allLocationSelected &&
						Object.keys(group["all_locations"]).reduce(
							(acc, _id) => acc && group["all_locations"][_id][0],
							true
						);
				} else {
					allLocationSelected = allLocationSelected && group["group_assigned"];
				}
			});
			setGroups(Object.assign([], groups));
			// console.log("allLocationSelected", allLocationSelected);
			setAssignmentStatus((prev: any) => {
				return { ...prev, all_groups: allGroupSelected, all_locations: allLocationSelected };
			});
		},
		[groups]
	);

	const handleAssignLocation = useCallback(
		async (groupId: string, id: string, assigned: boolean) => {
			let allLocationSelected = true;
			let allGroupSelected = true;

			groups.forEach((group: any) => {
				if (group._id == groupId) {
					group["all_locations"][id][0] = assigned;

					const atLeatstOneSelectedLocations = Object.keys(group["all_locations"]).reduce(
						(acc, _id) => acc || group["all_locations"][_id][0],
						group["group_assigned"]
					);

					group["group_assigned"] = atLeatstOneSelectedLocations;

					setGroups(Object.assign([], groups));
				}
				if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
					allLocationSelected =
						allLocationSelected &&
						Object.keys(group["all_locations"]).reduce(
							(acc, _id) => acc && group["all_locations"][_id][0],
							true
						);
				}
				allGroupSelected = allGroupSelected && group["group_assigned"];
			});

			setAssignmentStatus((prev: any) => {
				return { ...prev, all_locations: allLocationSelected, all_groups: allGroupSelected };
			});
		},
		[groups]
	);

	const handleSaveAllGroups = useCallback(async () => {
		if (!assignmentStatus?.all_groups && assignmentStatus) {
			groups.forEach((group: any) => {
				group["group_assigned"] = true;
			});
			setGroups(Object.assign([], groups));
			setAssignmentStatus({ ...assignmentStatus, all_groups: true });
		} else if (assignmentStatus) {
			groups.forEach((group: any) => {
				if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
					Object.keys(group["all_locations"]).forEach((_id: string) => {
						group["all_locations"][_id][0] = false;
					});
				}
				group["group_assigned"] = false;
			});
			setGroups(Object.assign([], groups));
			setAssignmentStatus({ ...assignmentStatus, all_groups: false, all_locations: false });
		}
	}, [assignmentStatus, groups]);

	const handleAssignSelectedLocationsToTheGroups = useCallback(async () => {
		const _groups: AssignedGroup[] = [],
			_locations: AssignedLocation[] = [],
			user_id = state.user_id;

		groups.forEach((group: GroupsAndLocations) => {
			const { _id, group_number } = group;

			if (group["group_assigned"]) {
				const group_id = _id;
				_groups.push({
					user_id,
					group_number,
					group_id,
					assigned: true,
					access: "read"
				});
				if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
					Object.keys(group["all_locations"]).forEach((_id: string) => {
						if (group["all_locations"][_id][0]) {
							_locations.push({
								user_id,
								group_id,
								location_number: group["all_locations"][_id][1],
								group_number,
								location_name: group["all_locations"][_id][2],
								location_id: _id,
								access: "read",
								assigned: true
							});
						}
					});
				}
			}
		});

		const payload = {
			groups: _groups,
			locations: _locations,
			assignmentStatus: {
				user_id,
				all_groups: assignmentStatus?.all_locations ? true : assignmentStatus?.all_groups,
				all_locations: assignmentStatus?.all_locations
			}
		};

		const result = (await trackPromise(api.assignGroupsAndLocation.assignSelectedLocationsToTheGroup(payload))) as {
			groupsAndLocations: GroupsAndLocations[];
			assignmentStatus: AssignmentStatus;
		};
		if (result) {
			result.groupsAndLocations.forEach((group: any) => {
				const all_locations: any = {};
				const { _id, unassigned_locations, assigned_locations, group_number } = group;
				unassigned_locations.forEach((location: any) => {
					const { _id, location_number, location_name } = location;
					all_locations[_id] = [];
					all_locations[_id].push(false);
					all_locations[_id].push(location_number);
					all_locations[_id].push(location_name);
				});
				assigned_locations.forEach((location: any) => {
					const { _id, location_number, location_name } = location;
					all_locations[_id] = [];
					all_locations[_id].push(true);
					all_locations[_id].push(location_number);
					all_locations[_id].push(location_name);
				});
				group["all_locations"] = all_locations;
				group["group_assigned"] = group.assigned_group_info ? group.assigned_group_info.assigned : false;
			});
			setGroups(Object.assign([], result.groupsAndLocations));
			setAssignmentStatus(Object.assign({}, result.assignmentStatus));
			alert("Groups and Locations assigning Updated successfully");
		} else {
			alert("Failed to update assigning Groups and Locations");
		}
	}, [assignmentStatus?.all_groups, assignmentStatus?.all_locations, groups, state.user_id]);

	const handleSaveAllLocations = useCallback(async () => {
		if (!assignmentStatus?.all_locations) {
			groups.forEach((group: any) => {
				if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
					Object.keys(group["all_locations"]).forEach((_id: string) => {
						group["all_locations"][_id][0] = true;
					});
				}

				group["group_assigned"] = true;
			});
			setGroups(Object.assign([], groups));
			setAssignmentStatus((prev: any) => {
				return { ...prev, all_locations: true, all_groups: true };
			});
		} else {
			groups.forEach((group: any) => {
				if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
					Object.keys(group["all_locations"]).forEach((_id: string) => {
						group["all_locations"][_id][0] = false;
					});
				}

				group["group_assigned"] = false;
			});
			setGroups(Object.assign([], groups));
			setAssignmentStatus((prev: any) => {
				return { ...prev, all_locations: false, all_groups: false };
			});
		}
		// const payload = {
		// 	groups: _groups,
		// 	locations: _locations,
		// 	assignmentStatus: {
		// 		user_id,
		// 		all_groups: !assignmentStatus?.all_locations ? true : assignmentStatus?.all_groups,
		// 		all_locations: !assignmentStatus?.all_locations
		// 	}
		// };

		// const result = (await trackPromise(api.assignGroupsAndLocation.assignAllLocations(payload))) as {
		// 	groupsAndLocations: GroupsAndLocations[];
		// 	assignmentStatus: AssignmentStatus;
		// };
		// if (result) {
		// 	console.log("result.assignmentStatus", result.assignmentStatus);
		// 	setAssignmentStatus(Object.assign({}, result.assignmentStatus));
		// 	setGroups(Object.assign([], result.groupsAndLocations));
		// }
	}, [assignmentStatus?.all_locations, groups]);

	const getAssignedToUser = useCallback(async () => {
		// console.log("state", state);
		if (state.role === "EMPLOYER") {
			const _employer = await api.groupOwner.getGroupOwnerById(state.user_id);
			setEmployer(Object.assign({}, _employer));
			// console.log("employer iii", _employer);
		} else {
			setEmployer(null);
		}
	}, [state]);

	useEffect(() => {
		if (groups && groups.length > 0) {
			let allLocationSelected = true;

			groups.forEach((group: any) => {
				if (group && Object.keys(group).length > 0) {
					const group_number = group.group_number;
					// const { _id, unassigned_locations, assigned_locations, group_number } = group;
					let allSelected = true;
					if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
						Object.keys(group["all_locations"]).forEach((_id: any) => {
							allSelected = allSelected && group["all_locations"][_id][0];
						});
					}
					setIsSelectAllLocations((prev: any) => {
						return { ...prev, [group_number]: allSelected };
					});
					if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
						allLocationSelected =
							allLocationSelected &&
							Object.keys(group["all_locations"]).reduce(
								(acc, _id) => acc && group["all_locations"][_id][0],
								true
							);
					}
				}
			});

			setAssignmentStatus((prev: any) => {
				return { ...prev, all_locations: allLocationSelected };
			});

			// console.log(groups, isSelectAllLocations);
		}
	}, [groups]);

	useEffect(() => {
		getGroups();
		getAssignedToUser();
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.limit_groups);
	}, [getAssignedToUser, getGroups, setDashboardHeader]);

	return (
		<div className="assign-groups">
			<div className="assign-groups-container">
				<Grid container spacing={2} style={{ height: "100%" }}>
					<Grid item xl={4} lg={4} md={4} xs={12} sm={12}>
						<Suspense fallback={<div />}>
							{assignmentStatus && employer !== undefined ? (
								<TreeView
									handleAssignSelectedLocationsToTheGroups={handleAssignSelectedLocationsToTheGroups}
									handleSelectAllLocationsClick={handleSelectAllLocationsClick}
									groups={groups}
									assignmentStatus={assignmentStatus}
									handleAssignGroup={handleAssignGroup}
									handleAssignLocation={handleAssignLocation}
									handleSaveAllGroups={handleSaveAllGroups}
									handleSaveAllLocations={handleSaveAllLocations}
									handleSelectProfile={handleSelectProfile}
									employer={employer}
								/>
							) : null}
						</Suspense>
					</Grid>
					<Grid item xl={8} lg={8} md={8} xs={12} sm={12} className="group-info">
						<Suspense fallback={<div />}>
							{groupInformation || locationInformation ? (
								<GroupInformation />
							) : (
								<div className="no-result">
									<span>
										<SelectAllIcon />
									</span>
									Select a group/or location
								</div>
							)}
						</Suspense>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default AssignGroups;
